import { Typography, Form, Row, Col, Input, Button, message } from 'antd';
import React, { memo, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  getCurrentOrganization,
  getCurrnetUserData,
} from 'store/slices/loginSlice';
import { getUserWeightSetting, updateUserSetting } from './SettingFunction';

const UserWeightSetting = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const currnetOrg = useSelector(getCurrentOrganization);
  const loginUsrOrg = useSelector(getCurrnetUserData);
  const orgId = currnetOrg?.id || loginUsrOrg?.organizationID;
  // get user weight setting data
  const listUserWeight = async () => {
    try {
      const res = await getUserWeightSetting({ id: orgId });
      let weights = res?.data?.getOrganization?.weightSettings;
      if (weights) {
        form.setFieldsValue({
          SMEWeight: weights.find((val) => val.role === 'SME')?.weight,
          LeaderWeight: weights.find((val) => val.role === 'LEADER')?.weight,
          AdminWeight: weights.find((val) => val.role === 'ADMIN')?.weight,
        });
      }
    } catch (error) {
      message.error(error.message);
    }
  };

  useEffect(() => {
    listUserWeight();
    // eslint-disable-next-line
  }, []);

  // update user weight function
  const updateUserWeightData = async (e) => {
    setLoading(true);
    const input = {
      id: orgId,
      weightSettings: [
        { role: 'SME', weight: e.SMEWeight },
        { role: 'LEADER', weight: e.LeaderWeight },
        { role: 'ADMIN', weight: e.AdminWeight },
      ],
    };
    try {
      await updateUserSetting(input);
      message.success(`User weight updated successfully`);
      listUserWeight();
      setLoading(false);
    } catch (error) {
      message.error(error.message);
      setLoading(false);
    }
  };

  return (
    <>
      <div>
        <Typography.Title level={4} className="text-black fw-500">
          Configure User Weight
        </Typography.Title>
        <Form
          layout="vertical"
          requiredMark={false}
          form={form}
          onFinish={updateUserWeightData}
        >
          <Row className="mt-30" gutter={10}>
            <Col span={6} md={6} sm={24} xs={24}>
              <Form.Item
                label={<span>Team Member Weight</span>}
                name="SMEWeight"
                rules={[
                  {
                    required: true,
                    message: 'Please enter SME Weight',
                  },
                  {
                    pattern: /^[0-9]+([.][0-9]+)?$/,
                    message: 'Please enter a valid number!',
                  },
                ]}
              >
                <Input placeholder="Please enter SME Weight" />
              </Form.Item>
            </Col>
            <Col span={6} md={6} sm={24} xs={24}>
              <Form.Item
                label={<span>Leader Weight</span>}
                name="LeaderWeight"
                rules={[
                  {
                    required: true,
                    message: 'Please enter Leader Weight',
                  },
                  {
                    pattern: /^[0-9]+([.][0-9]+)?$/,
                    message: 'Please enter a valid number!',
                  },
                ]}
              >
                <Input placeholder="Please enter Leader Weight" />
              </Form.Item>
            </Col>
            <Col span={6} md={6} sm={24} xs={24}>
              <Form.Item
                label={<span>Admin Weight</span>}
                name="AdminWeight"
                rules={[
                  {
                    required: true,
                    message: 'Please enter Admin Weight',
                  },
                  {
                    pattern: /^[0-9]+([.][0-9]+)?$/,
                    message: 'Please enter a valid number!',
                  },
                ]}
              >
                <Input placeholder="Please enter Admin Weight" />
              </Form.Item>
            </Col>
            <Col span={6} md={6} sm={24} xs={24}>
              <Row justify="end">
                <Form.Item label=" ">
                  <Button
                    htmlType="submit"
                    className="blue-filled-btn "
                    size="middle"
                    type="primary"
                    loading={loading}
                  >
                    Save
                  </Button>
                </Form.Item>
              </Row>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
};

export default memo(UserWeightSetting);

